import {REQUEST_STATUS, ROUTE_PATH} from '../../app/constants'

const loadInitialStateObject = (sliceName) => {
    switch(sliceName) { 
        case 'notEligible' : 
            return notEligibleState()
        case 'rjscSearch' : 
            return rjscSearch()
        case 'rjscDetailReview' : 
            return rjscDetailReview()
        case 'addressForService' : 
            return addressForService()
        case 'suretyBond' :
            return suretyBond()
        default : 
            return {}
    }
}

const suretyBond = () => ({
    header : "Surety bond",
    text : [
        "A surety bond for $20,000 is required before your application can be approved. Confirm that you will mail your surety bond to the following address before you continue."
    ],
    navigation : {
        next : ROUTE_PATH.APPLICATION_REVIEW
    }
})

const addressForService = () => ({
        header : "Address for service",
        headerRenewal : "Address for service",
        text : [
            "Provide a street address for notice of service and delivery of documents in Nova Scotia. The address can't be a PO Box."
        ],
        textRenewal : [
            "Review the street address for notice of service and delivery of documents in Nova Scotia."
        ],
        navigation : {
            next : ROUTE_PATH.FINANCIAL_RECORDS_LOCATION
        },
        addressTextHeader : "Street address",
        cityTextHeader : "City/Town",
        postalCodeTextHeader : "Postal code"
    }
)

const rjscDetailReview = () => ({
    header : "Review business information",
    text : [
        "If your business information is out of date, you must update it with Registry of Joint Stock Companies (RJSC) before you continue your application."
    ],
    navigation : {
        next : ROUTE_PATH.BUSINESS_CONTACT
    },
    updateRjscDetailDialog : {
        header : "Update your business information",
        htmlText : "<p>Before you apply, your business information needs to be updated in the Registry of Joint Stock Companies (RJSC).</p><p>It could take 5-10 business days for changes to be udpated in RJSC because they must be manually reviewed. You can continue your application after your changes are confirmed and applied in RJSC.</p>",
        htmlTextRenewal : "<p>Before you continue your renewal application, your business information must be up-to-date in the Registry of Joint Stock Companies (RJSC).</p><p>It could take 5-10 business days for changes to be udpated in RJSC because they must be manually reviewed. You can continue your renewal application after your changes are confirmed and applied in RJSC.</p>",
        navigation : {
            next : '/'
        }
    }
})

const notEligibleState = () => ({
    header: '',
    text : [
        "Only companies that collect debt in Nova Scotia on behalf on other companies are eligible for this licence."
    ],
    navigation : {
        next : '/'
    }
})

const rjscSearch = () => ({
    header : "Find your business",
    text : [
        "Enter your company’s legal name or Registry of Joint Stock Companies (RJSC) number to review your company information:"
    ],
    inputHeaderRjscNameSearch : "Search by company name",
    inputHeaderRjscNumberSearch : "Search by RJSC number",
    searchGetUrl : "https://caservice-genericmicroservices-dev.apps.nonprod.novascotia.ca/businesslicence/v1/rjsc/",
    navigation : {
        next : ROUTE_PATH.RJSC_SEARCH_SELECT,
        back : ROUTE_PATH.WELCOME
    },
    searchText : "",
    searchStatus : REQUEST_STATUS.IDLE
})
export default loadInitialStateObject